import { JsonObject, JsonProperty } from 'typescript-json-serializer';

@JsonObject()
export default class PresetFormFieldDependency {
    constructor(@JsonProperty() readonly field: string) {}
}
